module.exports = __webpack_public_path__ + "assets/0a52332940ed29908009478ee7fc3321.mp3";